export default __webpack_public_path__ + "static/media/underline.b0ffe16f.svg";